import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  courseContainer: {
    padding: "18px 60px 0 60px",
    "&:nth-child(even)": {
      backgroundColor: "#fbfbfb",
      "& $noteTextCounter": {
        backgroundColor: "#fbfbfb"
      }
    },
    borderBottom: "1px solid #eeeeee",
    [theme.breakpoints.down("md")]: {
      padding: "18px 34px 0 34px"
    },
    [theme.breakpoints.down("sm")]: {
      padding: "18px 18px 0 18px"
    }
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 18
  },
  track: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  trackIcon: {
    marginRight: 8,
    width: 28,
    height: 20
  },
  trackName: {
    fontWeight: 700,
    color: "#1a1a1a",
    fontSize: 18
  },
  lastUpdate: {
    fontSize: 14
  },
  lastUpdatePrefix: {},
  lastUpdateValue: {
    fontWeight: 600
  },
  fromTo: {
    fontSize: 12,
    color: theme.palette.text.secondary,
    textAlign: "right",
    minHeight: 18
  },
  conditionSelectionBlock: {
    // padding: "0 16px",
    marginBottom: 10
  },
  conditionTitle: {
    color: theme.palette.text.secondary,
    fontSize: 16,
    marginBottom: 2
  },
  hasChangesIndicator: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.secondary.dark,
    display: "inline-block",
    marginLeft: 4
  },
  conditionSelect: {
    "& .MuiInputBase-root": {
      fontSize: 20,
      color: theme.palette.text.primary
    }
  },
  conditionSelector: {
    width: "100%",
    "&.Mui-focused": {
      "& .MuiSelect-icon": {
        color: theme.palette.secondary.dark
      }
    },
    "& .MuiSelect-root": {
      "& .MuiSvgIcon-root": {
        display: "none"
      }
    },
    "& .MuiSelect-select": {
      "&:focus": {
        backgroundColor: "unset"
      }
    },
    "&.MuiInput-underline": {
      "&::after": {
        borderColor: theme.palette.secondary.dark,
        borderWidth: 1
      }
    },
    "&:focus": {
      outline: "none"
    },
    "&:hover": {
      "&.MuiInput-underline": {
        "&::before": {
          borderColor: theme.palette.secondary.dark,
          borderWidth: 1
        }
      },
      "& .MuiSelect-icon": {
        color: theme.palette.secondary.dark
      }
    }
  },
  menuItem: {
    borderBottom: "1px solid rgba(238, 238, 238, 1)",
    display: "flex",
    justifyContent: "space-between"
  },
  menuItemText: {},
  selectedMenuItem: {
    color: theme.palette.secondary.dark
  },
  conditionNote: {
    padding: "16px 0"
  },
  conditionNoteHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12
  },
  conditionNoteTitle: {
    color: theme.palette.text.secondary,
    fontSize: 16
  },
  deleteNoteButton: {
    color: theme.palette.text.secondary,
    width: 88,
    height: 24,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 1,
    padding: 0
  },
  deleteNoteButtonIcon: {
    fontSize: 14,
    marginRight: 4
  },
  deleteNoteButtonText: {
    color: theme.palette.text.secondary,
    fontSize: 12
  },
  conditionNoteBody: {
    position: "relative"
  },
  noteText: {
    width: "100%",
    borderRadius: 3,
    border: "1px solid rgba(186, 186, 186, 1)",
    padding: "12px 16px",
    minHeight: 94,
    maxHeight: 94,
    overflow: "auto",
    resize: "none",
    backgroundColor: "inherit",
    fontFamily: "inherit",
    "&:focus": {
      outline: "none",
      borderColor: theme.palette.secondary.dark
    }
  },
  noteTextFocus: {
    borderColor: theme.palette.secondary.dark
  },
  noteTextCounter: {
    position: "absolute",
    backgroundColor: theme.palette.common.white,
    bottom: "-3px",
    fontSize: "10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "50px",
    height: "16px",
    borderRadius: "3px",
    right: "10px",
    color: theme.palette.text.hint
  },
  placeholder: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: theme.palette.text.hint,
    textAlign: "center",
    "&:hover": {
      cursor: "text"
    }
  },
  placeholderIcon: {
    fontSize: "26px"
  },
  placeholderText: {
    lineHeight: 1,
    fontSize: "16px"
  },
  closeSaveButtonsContainer: {
    display: "flex",
    justifyContent: "flex-end",
    "& .MuiButton-root": {},
    "& .MuiButton-text": {
      padding: "2px 8px"
    }
  },
  cancelButton: {
    "& .MuiTypography-root": {
      color: theme.palette.text.hint
    }
  },
  cancelButtonText: {},
  saveButton: {
    "& .MuiTypography-root": {
      color: theme.palette.secondary.dark
    }
  },
  saveButtonText: {}
}));
